import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { getFacility, getFacilityError, getFacilityLoading } from '../../store/reducers/facilitySlice';
import { fetchFacility } from '../../store/actions/facilityActions';

export const useFacility = () => {
  const dispatch = useDispatch();
  const facility = useSelector(getFacility);
  const loading = useSelector(getFacilityLoading);
  const error = useSelector(getFacilityError);

  const loadFacility = useCallback(()=>{
    dispatch(fetchFacility())
  },[dispatch])

  return {
    facility,
    loading,
    error,
    loadFacility
  };
};
